import { render, staticRenderFns } from "./eventdetails.vue?vue&type=template&id=53197ce9&scoped=true&"
import script from "./eventdetails.vue?vue&type=script&lang=js&"
export * from "./eventdetails.vue?vue&type=script&lang=js&"
import style0 from "./eventdetails.vue?vue&type=style&index=0&id=53197ce9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53197ce9",
  null
  
)

export default component.exports